module.exports = __webpack_public_path__ + "img/template-tutorial-customize-spotify-after.befef07f.png";